const RELOAD_GUARD_KEY = 'scope:cache-reload-timestamp'
const DISMISSED_BUILD_KEY = 'scope:new-version-dismissed'

const RELOAD_GUARD_MS = 10_000

export function canReload(): boolean {
  const last = sessionStorage.getItem(RELOAD_GUARD_KEY)
  if (last && Date.now() - Number(last) < RELOAD_GUARD_MS) return false
  return true
}

export function reloadToLatestVersion() {
  if (!canReload()) return false
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))

  if ('caches' in window) {
    void caches.keys().then(keys => Promise.all(keys.map(key => caches.delete(key))))
  }

  window.location.reload()
  return true
}

export function getDismissedBuildId(): string | null {
  try {
    return localStorage.getItem(DISMISSED_BUILD_KEY)
  } catch {
    return null
  }
}

export function dismissNewVersion(buildId: string) {
  try {
    localStorage.setItem(DISMISSED_BUILD_KEY, buildId)
  } catch {
    return
  }
}

const CHUNK_RELOAD_KEY = 'scope:chunk-reload-attempts'
export const CHUNK_RELOAD_WINDOW_MS = 10 * 60_000
export const CHUNK_RELOAD_DELAYS_MS = [0, 1_000, 2_000, 5_000, 10_000]
export const CHUNK_RELOAD_MAX_DELAY_MS = 15_000

type ChunkReloadAttempts = { count: number; lastAt: number }

function readChunkReloadAttempts(now: number): number {
  try {
    const parsed = JSON.parse(
      sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 'null'
    ) as ChunkReloadAttempts | null
    if (parsed && now - parsed.lastAt < CHUNK_RELOAD_WINDOW_MS) return parsed.count
  } catch {
    return 0
  }
  return 0
}

function hardReload() {
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  if ('caches' in window) {
    void caches.keys().then(keys => Promise.all(keys.map(key => caches.delete(key))))
  }
  window.location.reload()
}

export function reloadAfterChunkError() {
  const now = Date.now()
  const count = readChunkReloadAttempts(now)
  const delay = CHUNK_RELOAD_DELAYS_MS[count] ?? CHUNK_RELOAD_MAX_DELAY_MS

  sessionStorage.setItem(CHUNK_RELOAD_KEY, JSON.stringify({ count: count + 1, lastAt: now }))

  if (navigator.onLine === false) {
    window.addEventListener('online', hardReload, { once: true })
    return
  }

  setTimeout(hardReload, delay)
}
